<template>
  <path pid="0" d="M22 9.84v-.26l-.05-.08-.1-.12-7-7-.08-.07H7A3 3 0 004 5v16a3 3 0 003 3h12a3 3 0 003-3V10a.62.62 0 000-.13zm-7-4.43L18.59 9H15zM20 21a1 1 0 01-1 1H7a1 1 0 01-1-1V5a1 1 0 011-1h6v6.12a1 1 0 001 .88h6z"/>
</template>
